/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultRecharge } from '../../models/api-response-paged-result-recharge';
import { PagedRequestRecharge } from '../../models/paged-request-recharge';

export interface SearchRecharges$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestRecharge
}

export function searchRecharges(http: HttpClient, rootUrl: string, params: SearchRecharges$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultRecharge>> {
  const rb = new RequestBuilder(rootUrl, searchRecharges.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultRecharge>;
    })
  );
}

searchRecharges.PATH = '/v1/api/ui/meta-pricing-analytics/recharge/search';
